// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__W8wJr","filesListContainer":"PosDisputesFiles_filesListContainer__2vTRk","filesButton":"PosDisputesFiles_filesButton__3LfS4"};